import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useEffect } from 'react';
import { fetchMeetings } from '@/api/v4/meetings.api';
import { QueryKey } from '@/config/query-client';
import { reorderMeetings } from '@/features/action-panel/meetings/helpers/reorder-meetings';
import { editedMeetingIdState } from '@/features/action-panel/meetings/meetings.state';

import { projectIdState } from '../../project.state';
import { useAtomValue } from 'jotai';

export const useProjectMeetings = () => {
  const queryClient = useQueryClient();
  const projectId = useAtomValue(projectIdState);
  const editedMeetingId = useAtomValue(editedMeetingIdState);

  const fetchProjectMeetings = async () => {
    if (!projectId) return [];

    return fetchMeetings({ projectId });
  };

  const query = useQuery({
    queryKey: [QueryKey.ProjectMeetings, projectId],
    queryFn: fetchProjectMeetings,
    select: meetings =>
      editedMeetingId ? reorderMeetings(meetings, editedMeetingId) : meetings,
    enabled: !!projectId,
    staleTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    if (query.data) {
      void queryClient.invalidateQueries({
        queryKey: [QueryKey.ProjectActionsInfo, projectId],
      });
    }
  }, [query.data, queryClient, projectId]);

  return query;
};
